<template>
  <div
    class="AdaptiveWidth"
    :style="{
      '--tiny': tiny,
      '--small': small,
      '--medium': medium,
      '--large': large,
      '--xlarge': xlarge,
      '--huge': huge,
      '--width': width ? width : '100%',
    }"
  />
</template>

<script>
export default {
  props: ['tiny', 'small', 'medium', 'large', 'xlarge', 'huge', 'width'],
};
</script>

<style scoped>
.AdaptiveWidth {
  width: var(--width);
  height: var(--tiny);
}
@media (min-width: 576px) {
  .AdaptiveWidth {
    width: var(--width);
    height: var(--small);
  }
}
@media (min-width: 768px) {
  .AdaptiveWidth {
    width: var(--width);
    height: var(--medium);
  }
}
@media (min-width: 1024px) {
  .AdaptiveWidth {
    width: var(--width);
    height: var(--large);
  }
}
@media (min-width: 1200px) {
  .AdaptiveWidth {
    width: var(--width);
    height: var(--xlarge);
  }
}
@media (min-width: 1600px) {
  .AdaptiveWidth {
    width: var(--width);
    height: var(--huge);
  }
}
@media (min-width: 1920) {
  .AdaptiveWidth {
    width: var(--width);
    height: var(--huge);
  }
}
</style>
